import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import MetaTags from "../../components/Common/MetaTags";
import Article from "../../components/Article";
import {
  getDocumentPaths,
  getSerializedDocumentBySlug,
} from "../../services/contentHelpers";

export default function Guide({ content, meta, host }) {
  return (
    <>
      <MetaTags
        overrides={{
          title: meta.title,
          description: meta.description,
          image: meta.coverImage,
        }}
      />

      <Article
        context="case-studies"
        content={content}
        meta={meta}
        host={host}
      />
    </>
  );
}

export function getStaticPaths() {
  return {
    paths: getDocumentPaths("case-studies"),
    fallback: false,
  };
}

export async function getStaticProps({ locale, params }) {
  const { content, headline, ...meta } = await getSerializedDocumentBySlug(
    "case-studies",
    params.slug,
    locale
  );

  return {
    props: {
      content,
      headline,
      meta,
      host: process.env["DEPLOY_PRIME_URL"] || null,
      ...(await serverSideTranslations(locale, ["common", "case-studies"])),
    },
  };
}
